<template>
  <div class="row">
    <div class="col-12">
      <editCommittee
        :isEdit="committee.id != undefined"
        :committee="committee"
      ></editCommittee>
    </div>
  </div>
</template>
<script>
import editCommittee from "../committee";
export default {
  name: "editCommitteePage",
  components: {
    editCommittee,
  },
  data() {
    return {
      committee: {},
    };
  },
  created() {
    let id = this.$route.params.id;
    this.$store
      .dispatch("get", "/api/v1/committees/" + id)
      .then((data) => {
        let temp = data.data.data;
        this.committee = { ...temp };
      })
      .catch((error) => {
        console.log(error.request);
      });
  },
};
</script>
